import {
  ContactAddress,
  ContactAddresses,
  ContactDetail,
  ContactDetailCompany,
  ContactDetailPerson,
} from '@shared/interfaces/contacts';
import { ContactAddressesDto, ContactDetailDto } from '@shared/interfaces/dtos/contacts';

export abstract class ContactsMapper {
  public static toContactAddresses(addresses: ContactAddressesDto): ContactAddresses {
    const mappedAddresses: ContactAddresses = [];

    for (const address of addresses) {
      const mappedAddress: ContactAddress = {
        type: address.type === 'PRINCIPALE' ? 'main' : address.type === 'SECONDAIRE' ? 'secondary' : 'other',
        id: address.id,
        countryId: address.adresse.structure_Localite?.pays.id ?? null,
        postalCode: address.adresse.structure_Localite?.codePostal ?? null,
        localityId: address.adresse.structure_Localite?.id ?? null,
        localityName: address.adresse.structure_Localite?.localite ?? null,
        streetId: address.adresse.structure_Rue?.id ?? null,
        streetCode: address.adresse.structure_Rue?.codeRue ?? null,
        streetName: address.adresse.structure_Rue?.rueNom ?? null,
        streetNumber: address.adresse.structure_RueNumero ?? null,
        streetBoxNumber: address.adresse.structure_RueBoite ?? null,
        phoneNumber: address.adresse.telephone ?? null,
        email: address.adresse.mail ?? null,
      };

      mappedAddresses.push(mappedAddress);
    }

    return mappedAddresses;
  }

  private static toContactDetailBase(contact: ContactDetailDto) {
    return {
      id: contact.id,
      typeContactId: contact.typeContactId,
      internalName: contact.nomInterne,
      fonction: contact.fonction,
      languageId: contact.langueId,
      active: !contact.nePlusUtiliser,
      comments: contact.commentaires,
    };
  }

  private static toContactDetailPerson(contact: ContactDetailDto): ContactDetailPerson {
    return {
      ...ContactsMapper.toContactDetailBase(contact),
      isCompany: false,
      title: contact.titre ?? null,
      registerNumber: contact.numeroCarteNISS ?? null,
      nationality: contact.nationalite ?? null,
      comment: contact.commentaires ?? null,
      firstname: contact.prenom ?? null,
      lastname: contact.nom,
      hasAccessToIDelibeMandataire: contact.accesModuleExterneDelibe,
      iDelibeMandatairesLogin: contact.loginDelibeWeb ?? '',
    };
  }

  private static toContactDetailCompany(contact: ContactDetailDto): ContactDetailCompany {
    return {
      ...ContactsMapper.toContactDetailBase(contact),
      isCompany: true,
      name: contact.nom,
      tva: contact.tva,
      tvaDigits: contact.tvA_Digits,
      noTvaBelgian: contact.pasDeTVABelge,
      bce: contact.bce,
      comment: '',
      companyManager: contact.gerantSociete,
      businessSector: contact.secteurActivite,
      hasAccessToIDelibeMandataire: contact.accesModuleExterneDelibe,
      iDelibeMandatairesLogin: contact.loginDelibeWeb ?? '',
    };
  }

  public static toContactDetail(contact: ContactDetailDto): ContactDetail {
    return contact.typeSociete
      ? ContactsMapper.toContactDetailCompany(contact)
      : ContactsMapper.toContactDetailPerson(contact);
  }
}
